export default "__VITE_ASSET__kIRgfslS__"